import {
  columnFilteringFeature,
  columnSizingFeature,
  columnVisibilityFeature,
  createColumnHelper,
  createExpandedRowModel,
  createFilteredRowModel,
  createPaginatedRowModel,
  createSortedRowModel,
  globalFilteringFeature,
  rowExpandingFeature,
  rowPaginationFeature,
  rowSelectionFeature,
  rowSortingFeature,
  sortFn_alphanumeric,
  sortFn_datetime,
  sortFn_text,
  tableFeatures,
  type Cell as TanstackCell,
  type CellData,
  type Column as TanstackColumn,
  type Header as TanstackHeader,
  type ReactTable,
  type Row as TanstackRow,
  type RowData,
} from "@tanstack/react-table";
import { editFeature } from "./features/edit";
import { rangeSelectFeature } from "./features/range-select";
import { selectedAllFeature } from "./features/selected-all";

export const appTableFeatures = tableFeatures({
  rowSelectionFeature,
  rowSortingFeature,
  columnFilteringFeature,
  globalFilteringFeature,
  rowPaginationFeature,
  rowExpandingFeature,
  columnVisibilityFeature,
  columnSizingFeature,
  editFeature,
  rangeSelectFeature,
  selectedAllFeature,
  filteredRowModel: createFilteredRowModel(),
  sortedRowModel: createSortedRowModel(),
  sortFns: {
    alphanumeric: sortFn_alphanumeric,
    datetime: sortFn_datetime,
    text: sortFn_text,
  },
  paginatedRowModel: createPaginatedRowModel(),
  expandedRowModel: createExpandedRowModel(),
});

export type AppFeatures = typeof appTableFeatures;

export type Table<TData extends RowData> = ReactTable<AppFeatures, TData>;
export type Row<TData extends RowData> = TanstackRow<AppFeatures, TData>;
export type Column<
  TData extends RowData,
  TValue extends CellData = CellData,
> = TanstackColumn<AppFeatures, TData, TValue>;
export type Cell<
  TData extends RowData,
  TValue extends CellData = CellData,
> = TanstackCell<AppFeatures, TData, TValue>;
export type Header<
  TData extends RowData,
  TValue extends CellData = CellData,
> = TanstackHeader<AppFeatures, TData, TValue>;

export const createAppColumnHelper = <TData extends RowData>() =>
  createColumnHelper<AppFeatures, TData>();
